import React, { useEffect, useState } from "react";
import { notify, getPractice, numberWithCommas } from "../../../helpers";
import { useDocumentTitle } from "../../../hooks/customDocumentTitleHook";
import Spacing from "../../Spacing";
import { Search } from "lucide-react";
import DataTablePagination from "../../DataTablePagination";
import InvoicesDataTable from "../../DataTable/InvoicesDataTable";
import FormViewDetailsModal from "../../Modal/FormViewDetailsModal";
import { getInvoicesData } from "../../../services/billing";

export default function Invoices({selectedPracticeChange, fetchChangePracticeData}) {

  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [invoiceList, setInvoiceList] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [formViewId, setFormViewId] = useState(null);
  const [formView, setFormView] = useState(false);

  const [filter, setFilter] = useState({
    page: 1,
    per_page: 10,
    search_term: "",
    order_by: [],
  });

  const [paginationCount, setPaginationCount] = useState({
    totalCount: 0,
    totalPages: 0,
  });

  useEffect(() => {
    loadAllInvoices(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const loadAllInvoices = async (filter) => {
    setFilter(filter);
    let isCanceled = false;

    try {
      const response = await getInvoicesData( filter, account_id, location_id );
      const updatedData = response.data?.results?.map((row) => ({
        ...row,
        checked: false,
      }));
      setInvoiceList(updatedData);
      setPaginationCount({
        totalCount: response.data.count,
        totalPages: response.data.total_pages,
      });
    } catch (error) {
      if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
        isCanceled = true;
      } else {
        notify("error", 'Something went wrong');
      }
    } finally {
      if (!isCanceled) {
        setDataLoading(false);
      }
    }
  };

  const handlePageChange = (newPage) => {
    setFilter({ ...filter, page: newPage });
    setDataLoading(true);
  };

  const handleChangeSearchTerm = (event) => {
    setFilter({ ...filter, search_term: event.target.value });
    setDataLoading(true);
  };

  const handleChangeRowsPerPage = (value) => {
    setFilter({
      ...filter,
      page: 1,
      per_page: value,
    });
    setDataLoading(true);
  };

  useEffect(() => {
    const sameLocation = filter.location_id === location_id;
    const sameAccount = filter.account_id === account_id;

    if (sameLocation && sameAccount) return;

    setFilter({
      ...filter,
      location_id: location_id,
      account_id: account_id,
    });
    setDataLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location_id, account_id]);

  const handleFormView = (formId) => {
    setFormViewId(formId)
    setFormView(true);
  };
  const handleFormPrint = (formId) => {
    const url = `/invoice/print?form_id=${formId}&size=A4`;
    window.open(url, '_blank');
  };

  useDocumentTitle("Invoices");

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
          Invoices
          <span>{numberWithCommas(paginationCount.totalCount)}</span>
        </h2>
      </div>
      <Spacing lg="20" sm="20" />
      <div className="docpro_data_table_wrap">
        <div className="docpro_data_table_headings">
          <form className="docpro_search_form">
            <input
              type="text"
              placeholder="Search"
              className="docpro_search_input"
              onChange={handleChangeSearchTerm}
            />
            <button className="docpro_search_btn">
              <Search width={20} height={20} />
            </button>
          </form>
        </div>

        <InvoicesDataTable
          tableData={invoiceList || []}
          reloadData={loadAllInvoices}
          reloadDataFilter={filter}
          dataLoading={dataLoading}
          setDataLoading={setDataLoading}
          handleFormView={handleFormView}
          handleFormPrint={handleFormPrint}
        />
        {(invoiceList.length > 0 && !dataLoading) && (
          <DataTablePagination
            currentPage={filter.page}
            totalPages={paginationCount.totalPages}
            onPageChange={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalRecords={paginationCount.totalCount}
            currentPageData={filter.per_page}
          />
        )}
      </div>

      {formViewId && (
        <FormViewDetailsModal
          formId = {formViewId}
          formSize = {'A4'}
          formView = {formView}
          setFormView = {setFormView}
          formType = {'invoice'}
        />
      )}
    </>
  );
}
